import { fmt } from '../../utils/formatters';

export default function Sidebar({ tab, setTab, view, stats, dailyLimit, apiOk, setView, onSettings, user, onLogout }) {
  const todaySales = stats.todaySales || 0;
  const dailyLimitMin = dailyLimit?.min ?? dailyLimit ?? 0;
  const pct = Math.min(100, Math.round((todaySales / dailyLimitMin) * 100));

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <span className="brand-emblem">🎂</span>
        <div className="brand-title">The Cakery</div>
        <div className="brand-sub">Invoice System</div>
      </div>

      <nav className="sidebar-nav">
        <div className="nav-group-label">Invoices</div>
        {[
          { key: 'sale', icon: '📦', label: 'Sales Invoices' },
        ].map(n => (
          <button
            key={n.key}
            className={`nav-item ${tab === n.key && view === 'list' ? 'active' : ''}`}
            onClick={() => { setTab(n.key); setView('list'); }}
          >
            <span className="nav-icon">{n.icon}</span>{n.label}
          </button>
        ))}

        <div className="nav-group-label" style={{ marginTop: 8 }}>Ledgers</div>
        {[
          { key: 'sale', icon: '📗', label: 'Sales Ledger', view: 'sales-ledger' },
          { key: 'purchase', icon: '📘', label: 'Purchase Ledger', view: 'purchase-ledger' },
        ].map(n => (
          <button
            key={n.view}
            className={`nav-item ${view === n.view ? 'active' : ''}`}
            onClick={() => { setTab(n.key); setView(n.view); }}
          >
            <span className="nav-icon">{n.icon}</span>{n.label}
          </button>
        ))}

        <div className="nav-group-label" style={{ marginTop: 8 }}>Tools</div>
        <button className={`nav-item ${view === 'drive-jobs' ? 'active' : ''}`} onClick={() => setView('drive-jobs')}>
          <span className="nav-icon">📁</span>Drive Jobs
        </button>
      </nav>

      {/* <div className="sidebar-panel">
        <div className="sp-title">Today's Summary</div>
        <div className="sp-row"><span>Sales</span><span className="sp-val">{fmt(stats.todaySales || 0)}</span></div>
        <div className="sp-row"><span>Invoices</span><span className="sp-val">{stats.todaySaleCount || 0}</span></div>
        <div className="sp-divider" />
        <div className="sp-row"><span>Purchases</span><span className="sp-val">{fmt(stats.todayPurchases || 0)}</span></div>
        <div className="sp-row"><span>Month Sales</span><span className="sp-val">{fmt(stats.monthSales || 0)}</span></div>
        <div className="sp-divider" />
        <div className="sp-row"><span>Daily Limit</span><span className="sp-val">{fmt(dailyLimitMin)}</span></div>
        <div className="limit-bar-wrap">
          <div className="limit-bar-track"><div className="limit-bar-fill" style={{ width: pct + '%' }} /></div>
          <div className="limit-bar-label"><span>{fmt(todaySales)}</span><span>{pct}%</span></div>
        </div>
      </div> */}

      <div className="sidebar-bottom">
        {user && (
          <div
            className="sidebar-user"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 8,
              padding: '8px 10px',
              marginBottom: 8,
              borderRadius: 8,
              background: 'rgba(255,255,255,0.06)',
            }}
          >
            <div style={{ overflow: 'hidden' }}>
              <div style={{ fontSize: 12.5, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {user.name || user.email}
              </div>
              {user.name && (
                <div style={{ fontSize: 11, opacity: 0.65, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {user.email}
                </div>
              )}
            </div>
            <button
              className="btn btn-ghost btn-sm"
              onClick={onLogout}
              title="Logout from Google"
              style={{ flexShrink: 0, cursor: 'pointer' }}
            >
              ⎋ Logout
            </button>
          </div>
        )}
        <button className="btn-settings" onClick={onSettings}>⚙ Settings & Limits</button>
        <div className="conn-text">
          <span className={`connection-dot ${apiOk ? 'ok' : 'err'}`} />
          {apiOk ? 'Online' : 'Offline'}
        </div>
      </div>
    </aside>
  );
}